import React, {memo} from 'react';

import {Skeleton} from '@mui/material';
import {Box} from '@mui/system';

import useWindowSize from '@/hooks/WindowSize/WindowSize';

import {EditInfoViewModelProvider} from './EditInfoViewModelContext';

const desktopOuterSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: '100vh',
  bgcolor: 'white',
};

const desktopInnerSx = {
  width: '100%',
  maxWidth: 560,
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  pt: '98px',
  pb: 4,
};

const desktopContentSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  px: '32px',
  py: '16px',
};

const desktopTextSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  alignItems: 'center',
};

const desktopButtonsSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

const mobileOuterSx = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  bgcolor: 'white',
};

const mobileLogoContainerSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  px: 2,
  pt: '63px',
  pb: 2,
};

const mobileContentSx = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  px: 3,
  pb: '40px',
  gap: '16px',
};

const mobileDescriptionSx = {
  width: '100%',
  textAlign: 'center',
};

const mobileButtonContainerSx = {
  px: 2,
  pb: '40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

function EditInfoSkeleton() {
  const {isMobile} = useWindowSize();

  if (!isMobile) {
    return (
      <Box sx={desktopOuterSx}>
        <Box sx={desktopInnerSx}>
          <Box sx={{display: 'flex', justifyContent: 'center', py: 1}}>
            <Skeleton
              variant="rectangular"
              width={128}
              height={24}
              sx={{borderRadius: 1}}
            />
          </Box>

          <Box sx={desktopContentSx}>
            <Box sx={desktopTextSx}>
              <Skeleton
                variant="text"
                width="80%"
                sx={{fontSize: '22px'}}
              />
              <Skeleton
                variant="text"
                width="60%"
                sx={{fontSize: '22px'}}
              />
              <Skeleton
                variant="text"
                width="100%"
              />
              <Skeleton
                variant="text"
                width="80%"
              />
            </Box>

            <Skeleton
              variant="rounded"
              width="100%"
              height={340}
              sx={{borderRadius: 2}}
            />

            <Box sx={desktopButtonsSx}>
              <Skeleton
                variant="rounded"
                width="100%"
                height={44}
                sx={{borderRadius: '100px'}}
              />
              <Skeleton
                variant="rounded"
                width="100%"
                height={44}
                sx={{borderRadius: '100px'}}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={mobileOuterSx}>
      <Box sx={mobileLogoContainerSx}>
        <Skeleton
          variant="rectangular"
          width={128}
          height={24}
          sx={{borderRadius: 1}}
        />
      </Box>

      <Box sx={mobileContentSx}>
        <Skeleton
          variant="rounded"
          width={240}
          height={240}
        />

        <Box sx={mobileDescriptionSx}>
          <Skeleton
            variant="text"
            sx={{fontSize: '24px'}}
          />
          <Skeleton
            variant="text"
            sx={{fontSize: '24px', width: '70%', mx: 'auto'}}
          />
        </Box>

        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" />
          <Skeleton variant="text" />
          <Skeleton
            variant="text"
            sx={{width: '60%'}}
          />
        </Box>
      </Box>

      <Box sx={mobileButtonContainerSx}>
        <Skeleton
          variant="rounded"
          width="100%"
          height={44}
          sx={{borderRadius: '100px'}}
        />
        <Skeleton
          variant="rounded"
          width="100%"
          height={44}
          sx={{borderRadius: '100px'}}
        />
      </Box>
    </Box>
  );
}

const EditInfoPage = memo(() => (
  <EditInfoViewModelProvider>
    <EditInfoSkeleton />
  </EditInfoViewModelProvider>
));

export default EditInfoPage;
